export default function getMessages(state) {
    return state.appState.messages;
}
